module.exports = __webpack_public_path__ + "media/assets/images/tour/8a_Tour_4-39a6bb0052216d8cadc488ea70712bc7.png";